import * as Phaser from 'phaser';
import { BALANCE } from '@/config/balance';
import { TEXTURE_KEYS } from '@/utils/textures';
import type { Lane } from '@/types';

const HITBOX_SIZE = 40;

export class Monster extends Phaser.Physics.Arcade.Image {
  private currentLane: Lane = 1;

  constructor(scene: Phaser.Scene) {
    super(scene, 0, 0, TEXTURE_KEYS.monster);
    scene.add.existing(this);
    scene.physics.add.existing(this);
    this.setOrigin(0.5, 0.5);
    const body = this.body as Phaser.Physics.Arcade.Body | null;
    body?.setAllowGravity(false);
    body?.setSize(HITBOX_SIZE, HITBOX_SIZE, true);
    this.setActive(false).setVisible(false);
  }

  spawn(lane: Lane, speed: number): void {
    const x = BALANCE.lanes.positions[lane];
    if (x === undefined) return;
    this.currentLane = lane;
    this.setPosition(x, BALANCE.spawn.spawnY);
    this.setActive(true).setVisible(true);
    this.setRotation(0);
    const body = this.body as Phaser.Physics.Arcade.Body | null;
    body?.setVelocity(0, speed);
  }

  reset(): void {
    this.setActive(false).setVisible(false);
    const body = this.body as Phaser.Physics.Arcade.Body | null;
    body?.setVelocity(0, 0);
  }

  getLane(): Lane {
    return this.currentLane;
  }

  isOutOfBounds(): boolean {
    return this.y > BALANCE.spawn.despawnY;
  }
}
